export default __webpack_public_path__ + "static/qawhat-4-724cd3c0c6c4066e358be2aca557b340.png";